import Dialog from "./index.vue";
export default {
  install(Vue) {
    Vue.component(Dialog.name, Dialog);
  }
}